import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { environment } from '../../environments/environment';
import {
  CheckoutRequest,
  EventCheckoutConfirmRequest,
  EventCheckoutRequest,
  EventTicketConfig
} from '../models/checkout.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService extends BaseService {
  override baseUrl = `${environment.apiUrl}/pagos`;
  eventPaymentsUrl = `${environment.apiUrl}/pagos/event-tickets`;

  createCheckout(body: CheckoutRequest) {
    return this.http.post<any>(`${this.baseUrl}/checkout`, body);
  }

  createEventCheckout(body: EventCheckoutRequest) {
    return this.http.post<any>(`${this.eventPaymentsUrl}/checkout`, body);
  }

  confirmEventCheckout(body: EventCheckoutConfirmRequest) {
    return this.http.post<any>(`${this.eventPaymentsUrl}/confirm`, body);
  }

  validateEventTicket(token: string) {
    return this.http.get<any>(`${this.eventPaymentsUrl}/validate/${token}`);
  }

  getEventTicketConfig() {
    return this.http.get<any>(`${this.eventPaymentsUrl}/config`).pipe(
      map((res) => res?.data || res?.Data || {}),
      map(
        (data): EventTicketConfig => ({
          event_id: Number(data?.event_id || 0),
          amount_cents: Number(data?.amount_cents || 0),
          currency: String(data?.currency || 'mxn'),
          product_name: String(data?.product_name || 'Boleto Summit UDEP 2026'),
          display_price: String(data?.display_price || '$700.00 MXN')
        })
      )
    );
  }
}
